import { render, staticRenderFns } from "./CustomerPackagesDetail.vue?vue&type=template&id=2f02e378&"
import script from "./CustomerPackagesDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerPackagesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports